/* eslint-disable max-len */
import React from 'react';
import {
  Table, Button, Spin, Modal, DatePicker, Divider,
  Popover,
} from 'antd';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
} from 'recharts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import CenteredContent from '@common/components/ui/CenteredContent';
import useTableNotification from './useTableNotification';
import styles from './TableNotification.module.less';

const { RangePicker } = DatePicker;

function TableNotification() {

  const {
    loading,
    dataSource,
    dataSourceModal,
    handleChangetable,
    columns,
    columnsDetail,
    onChangeRangeDates,
    reStartData,
    visible,
    valueType,
    columnsDataInfo,
  } = useTableNotification();
  const { t } = useTranslation();

  const AuxModal = () => (
    <>
      <Table
        className={styles.table}
        columns={columnsDataInfo}
        dataSource={valueType}
        // scroll={{ y: 440 }}
        style={{
          width: 600,
        }}
        pagination={{ pageSize: 6 }}
        rowKey={(record) => `${record.name}_${record.value}_${record.typeId}`}
      />
    </>
  );

  return (
    <div
      className={styles.cardTable}
    >
      <div className={styles.title}>
        <h2>{t('views.device_graphics.notification_table')}</h2>
      </div>
      {(() => {

        if (loading) {

          return (
            <>
              <CenteredContent>
                <Spin tip={t('common.feedbacks.loading_chart')} />
              </CenteredContent>
              <ResponsiveContainer className={styles.responsiveContainer} width="95%" height={300}>
                <>
                  <Modal
                    title={t('views.device_graphics.notification_table')}
                    centered
                    visible={visible}
                    onOk={() => {

                      reStartData();

                    }}
                    onCancel={() => {

                      reStartData();

                    }}
                    width={1000}
                  >
                    <div className={styles.RangePicker_info}>
                      <RangePicker
                        showTime
                        defaultValue={[dayjs().subtract(30, 'days'), dayjs()]}
                        onChange={onChangeRangeDates}
                      />
                      <p className={styles.textInfo}>{t('views.device_graphics.invertersLogs.MoreInfo')}</p>
                      <Popover content={AuxModal} placement="leftTop">
                        <FontAwesomeIcon className={styles.iconInfo} icon={faInfoCircle} />
                      </Popover>
                    </div>
                    <Divider />
                    <div>
                      <Table
                        className={styles.table}
                        columns={columnsDetail}
                        dataSource={dataSourceModal}
                        rowKey={(record) => `${record.time}_${record.inverter}_${record.name}`}
                      />
                    </div>
                  </Modal>
                </>
              </ResponsiveContainer>

            </>
          );

        }

        return (
          <ResponsiveContainer className={styles.responsiveContainer} width="99%" height={400}>
            <>
              <Table
                scroll={{ y: '63vh' }}
                className={styles.table}
                columns={columns}
                dataSource={dataSource}
                rowKey={(record) => `${record.time}_${record.inverter}_${record.name}`}
              />
              <Button
                onClick={() => {

                  handleChangetable();

                }}
                className={styles.btn}
                type="primary"
              >
                {t('views.device_graphics.view_detail')}
              </Button>

            </>
          </ResponsiveContainer>
        );

      })()}
    </div>
  );

}

TableNotification.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  className: PropTypes.string,
};

TableNotification.defaultProps = {
  className: null,
};

export default TableNotification;
